"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { LoanLoightLogo_LightIcon as LoanLightLogo } from "@/components/ui/LoanLoightLogo_LightIcon";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
export const InitializationError = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="sticky top-0 flex items-center px-8 py-4 bg-brand-900"><LoanLightLogo aria-label="LoanLight" height={28} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ExclamationTriangleIcon className="h-12 w-12 text-red-500" />;
    t2 = <h2 className="m-0 text-center text-[32px] font-medium text-zinc-900 tracking-[-0.96px] leading-none">Connection Failed</h2>;
    t3 = <p className="m-0 text-center text-base font-normal text-brand-950 leading-normal tracking-[-0.32px]">We were unable to connect to your Encompass session.</p>;
    t4 = <p className="m-0 text-center text-base font-normal text-brand-950 leading-normal tracking-[-0.32px]">Please refresh your browser and try again. If the issue persists, contact support.</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="min-h-screen flex flex-col bg-brand-900">{t0}<div className="flex flex-1 flex-col items-center pt-[4vh]"><div className="w-148 rounded-2xl bg-white shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_10px_10px_-5px_rgba(0,0,0,0.04)] flex flex-col items-center"><div className="flex flex-col items-center gap-4 p-8 w-full">{t1}{t2}{t3}{t4}<div className="w-full pt-4"><Button color="dark" className="w-full" onClick={_temp}>Refresh</Button></div></div></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
function _temp() {
  return window.location.reload();
}